import { render, staticRenderFns } from "./SubmittedProjectBuildings.vue?vue&type=template&id=2c04b041"
import script from "./SubmittedProjectBuildings.vue?vue&type=script&lang=js"
export * from "./SubmittedProjectBuildings.vue?vue&type=script&lang=js"
import style0 from "./SubmittedProjectBuildings.vue?vue&type=style&index=0&id=2c04b041&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports